import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";

const PersistLogin = () => {
  const [isVerifying, setIsVerifying] = useState(true);
  const refresh = useRefreshToken();
  const { auth, persist } = useAuth();

  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        await refresh(); // intenta renovar token
      } catch (err) {
        console.error("Error al refrescar token:", err);
      } finally {
        if (isMounted) setIsVerifying(false);
      }
    };

    if (!auth?.accessToken && persist) {
      // solo intenta refrescar si no hay token y persist está activo
      verifyRefreshToken();
    } else {
      // si ya hay token, no bloqueamos render
      setIsVerifying(false);
    }

    return () => {
      isMounted = false;
    };
  }, [auth?.accessToken, persist, refresh]);

  // 👇 clave: no renderizar Outlet hasta terminar de verificar
  if (isVerifying) {
    return (
      <div className="loading-overlay">
        <p>Verificando sesión...</p>
      </div>
    );
  }

  // cuando ya se verificó, render normal
  return <Outlet />;
};

export default PersistLogin;
